import React from 'react';
import {Button, Modal} from 'semantic-ui-react';

type ConflictWarningModalProps = {
  children?: React.ReactNode;
  onOverwrite: () => void;
  onCancel: () => void;
};

const ConflictWarningModal: React.FC<ConflictWarningModalProps> = ({
  onOverwrite,
  onCancel,
  children,
}) => {
  return (
    <Modal size="mini" open onClose={onCancel}>
      <Modal.Content>
        <h3>Potential conflict</h3>
        {children}
        <Button color="red" size="tiny" onClick={onOverwrite}>
          Overwrite changes
        </Button>
        <Button size="tiny" onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Content>
    </Modal>
  );
};

export default ConflictWarningModal;
